export class Cycle {
  cycleId: number;
  cycleName: string;
}
